import { I18n } from '@calendly/i18n';
import { HeadingText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDomainControls } from '../actions';
import { domainsListSelector } from '../selectors';
import { DomainCard } from './card';
const domainCardsContainerCss = "d1s0vsjk";
const DomainCardsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(domainCardsContainerCss, props.className)} />;
});
const domainsCardsWrapperCss = "d9k6tqq";
const DomainsCardsWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(domainsCardsWrapperCss, props.className)} />;
});
export const DomainCards = () => {
  const dispatch = useDispatch();
  const domains = useSelector(domainsListSelector);
  useEffect(() => {
    dispatch(getDomainControls());
  }, [dispatch]);
  if (!domains.length) {
    return null;
  }
  return <DomainCardsContainer>
      <HeadingText level={3}>{I18n.t('publisher.organization_settings.domain_control.cards.title')}</HeadingText>
      <DomainsCardsWrapper>
        {domains.map(domain => <DomainCard key={domain.uuid} domain={domain} />)}
      </DomainsCardsWrapper>
    </DomainCardsContainer>;
};

require("./cards.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./cards.js");